import { Footer, LeadForm, Navbar, Spinner } from "_components";
import {
  ContactPage,
  DestinationsPage,
  HomePage,
  ItineraryPage,
  PrivacyPage,
  TermsConditionsPage,
  ToursPage,
} from "_pages";
import { LeadFormAtom } from "_states";
import React from "react";
import { Outlet, Route, Routes } from "react-router-dom";
import { useRecoilState } from "recoil";

export default function App() {
  return (
    <main>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="destinations" element={<DestinationsPage />} />
          <Route path="tours" element={<ToursPage />} />
          <Route path="tours/:param" element={<ToursPage />} />
          <Route path="itinerary/:param" element={<ItineraryPage />} />
        </Route>
        <Route element={<PageLayout />}>
          <Route path="/terms-conditions" element={<TermsConditionsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<NoMatch />} />
        </Route>
      </Routes>
    </main>
  );
}

const Layout = () => {
  const [leadFormOpen, setLeadFormOpen] = useRecoilState(LeadFormAtom);
  return (
    <React.Suspense
      fallback={
        <div className="h-screen flex items-center justify-center">
          <Spinner />
        </div>
      }
    >
      <Navbar />
      <div className="mx-auto max-w-full">
        <Outlet />
      </div>
      {/* Benefits section */}
      <section className="max-w-7xl mx-auto pb-36 grid lg:grid-cols-4 sm:grid-cols-2 gap-6 justify-center items-center py-12 md:px-2 sm:px-4 px-4">
        <div className="lg:text-start md:text-center">
          <h3 className="text-4xl font-medium mb-8">
            Go beyond your
            <br />
            <span className="pb-3 border-b border-primary">imagination</span>
          </h3>
          <p className="text-slate-700">
            Discover your ideal experience with us
          </p>
        </div>
        <div className="relative bg-white flex justify-center rounded-xl overflow-hidden w-full h-96">
          <img
            src="/images/bimg1.png"
            className="rounded-xl object-cover h-full w-full transition ease-in-out duration-300 hover:scale-110 hover:brightness-50"
          />
          <span className="absolute bottom-8 text-white text-center text-2xl pointer-events-none">
            Discount on all
            <br />
            airlines
          </span>
        </div>
        <div className="relative bg-white flex justify-center rounded-xl overflow-hidden w-full h-96">
          <img
            src="/images/bimg2.png"
            className="rounded-xl object-cover h-full w-full transition ease-in-out duration-300 hover:scale-110 hover:brightness-50"
          />
          <span className="absolute bottom-8 text-white text-center text-2xl pointer-events-none">
            Travel around
            <br />
            the world
          </span>
        </div>
        <div className="relative bg-white flex justify-center rounded-xl overflow-hidden w-full h-96">
          <img
            src="/images/bimg3.png"
            className="rounded-xl object-cover h-full w-full transition ease-in-out duration-300 hover:scale-110 hover:brightness-50"
          />
          <span className="absolute bottom-8 text-white text-center text-2xl pointer-events-none">
            Top deals on
            <br />
            Luxury resorts
          </span>
        </div>
      </section>

      {/* Reviews section */}
      <section className="w-full bg-slate-100 space-y-8 py-24 md:px-2 sm:px-4 px-4">
        <h2 className="font-semibold text-4xl text-center mb-16">Reviews</h2>
        <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-y-16 md:gap-6">
          <div className="relative bg-white text-slate-700 rounded-lg p-8">
            <img
              src="/images/user1.jpg"
              alt="user"
              className="rounded-full h-16 absolute left-0 right-0 mx-auto -top-10"
            />
            "Loved the overall tour for all 6 days covering jaipur jodhpur and
            jaisalmer. worth ur money for sure. thanks. Driver was very good and
            polite and safe driving for all 6 days. on time pickup and drop
            overall. Thanks for it."
          </div>
          <div className="relative bg-white text-slate-700 rounded-lg p-8">
            <img
              src="/images/user2.jpg"
              alt="user"
              className="rounded-full h-16 absolute left-0 right-0 mx-auto -top-10"
            />
            "We had an amazing time in Bali. The itinerary was well-planned, and
            everything—from the beautiful beaches to the cultural sites—was spot
            on. The team took care of all the details, so we could just relax
            and enjoy.Highly recommend for any group looking to explore Bali."
          </div>
          <div className="relative bg-white text-slate-700 rounded-lg p-8">
            <img
              src="/images/user3.jpg"
              alt="user"
              className="rounded-full h-16 absolute left-0 right-0 mx-auto -top-10"
            />
            "Our Dubai trip was fantastic! Everything was smoothly organized,
            from the sightseeing to the shopping. The guides were friendly, and
            we got to explore all the must-see spots. Highly recommend this
            agency for a stress-free, fun trip!"
          </div>
        </div>
      </section>
      <Footer />
      <LeadForm
        open={leadFormOpen}
        onClose={() => {
          setLeadFormOpen(false);
        }}
        destination={""}
      />
    </React.Suspense>
  );
};

const PageLayout = () => {
  return (
    <>
      <Navbar type="dark" />
      <div className="mx-auto max-w-full mt-36">
        <Outlet />
      </div>
      <Footer />
    </>
  );
};

const NoMatch = () => {
  return (
    <div className="h-96 content-center text-center pt-20">Page not found</div>
  );
};
